"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentForJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const payment_record_1 = require("./payment-record");
const accounting_document_1 = require("../accounting-documents/accounting-document");
const payment_session_1 = require("./payment-session");
const entity_1 = require("../../util/entity");
const accounting_document_line_item_1 = require("../accounting-documents/accounting-document-line-item");
let PaymentForJobView = class PaymentForJobView extends payment_record_1.PaymentRecord {
};
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
    }),
    __metadata("design:type", String)
], PaymentForJobView.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: accounting_document_line_item_1.AccountingDocumentTargetEnum,
        nullable: false,
    }),
    __metadata("design:type", Array)
], PaymentForJobView.prototype, "targetType", void 0);
PaymentForJobView = __decorate([
    (0, typeorm_1.ViewEntity)({
        schema: 'payment',
        expression: (connection) => {
            const paymentRecordColumns = (0, entity_1.getEntityColumns)(payment_record_1.PaymentRecord, connection);
            const qb1 = connection
                .createQueryBuilder(accounting_document_1.AccountingDocument, 'document')
                .innerJoin('document.payments', 'payment')
                .innerJoin('document.jobs', 'job')
                .innerJoin('document.lineItems', 'line_item')
                .select('job.api_id__c', 'job_api_id')
                .groupBy('job.api_id__c, payment.id');
            const qb2 = connection
                .createQueryBuilder(payment_session_1.PaymentSession, 'payment_session')
                .innerJoin(payment_record_1.PaymentRecord, 'payment', 'payment.reference_number = payment_session.payment_reference')
                .select('payment_session.job_api_id', 'job_api_id');
            const columnsIterator = new entity_1.EntityColumnIterator({
                raw_data: true,
            });
            columnsIterator.all(paymentRecordColumns, (columnName) => {
                qb1.addSelect(`payment."${columnName}"`, columnName);
                qb2.addSelect(`payment."${columnName}"`, columnName);
            });
            const qb = connection
                .createQueryBuilder()
                .from(`(${qb1.getQuery()} UNION ${qb2.getQuery()})`, 'pfj')
                .select('pfj.*')
                .distinctOn(['"pfj"."id"']);
            const viewVersion = (0, entity_1.getViewVersion)(null, [accounting_document_1.AccountingDocument, payment_session_1.PaymentSession, payment_record_1.PaymentRecord], connection);
            qb.comment(`-- DDL checksum : ${viewVersion.hash}`);
            return qb;
        },
    })
], PaymentForJobView);
exports.PaymentForJobView = PaymentForJobView;
//# sourceMappingURL=payment-for-job-view.js.map